import { Injectable } from '@angular/core';
import { EventBus } from '../event-bus';

export type ModelEventBusEvents = '[Model] updated' | '[Model] created' | '[Model] deleted';

/**
 * ModelEventBus is responsible for emitting and listening to model domain events.
 * Provided on demand at the project route level so its lifetime matches the project context.
 */
@Injectable()
export class ModelEventBus extends EventBus<ModelEventBusEvents> {}
